
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import PreQuestionField from '@/components/PreQuestionField.vue';
import AppButton from '@/components/AppButton.vue';
import { MutationType } from '@/enums';
import {PreQuestion, SpecialEventOption} from '@/types';
import { t } from '@/utils';

@Component({
	components: {
		PreQuestionField,
		AppButton
	}
})
export default class PreQuestionSurvey extends Vue {
	private specialEventsOptions:SpecialEventOption[] = this.$store.getters.getSpecialEventsOptions;
	private isSpecialWeek:Boolean | null = null;
	private specialEvent:String[] = [""];

	toggleSelection(identifier: String) {
		const index = this.specialEvent.indexOf(identifier);
		if (index > -1) {
			// If the identifier is already in the array, remove it
			this.specialEvent.splice(index, 1);
		} else {
			this.specialEvent.push(identifier);
		}
	}

	private setSpecialWeek(value: boolean): void {
		this.isSpecialWeek = value;
	}

	private endRegistration(): void {
		// continue pop up
		let confirmQuestion = t('overview', 'finish_confirmation');

		if (!confirm(confirmQuestion)) {
			return;
		}

		this.finish();
	}

	@Emit()
	private finish(): void {
		this.$store.commit(MutationType.SET_SPECIAL_EVENT_ANSWERS, this.specialEvent);
	}
}
